"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtendedPublicKeys = void 0;
const internal_1 = require("../types/internal");
const assert_1 = require("../utils/assert");
const ioHelpers_1 = require("../utils/ioHelpers");
const serialize_1 = require("../utils/serialize");
const getVersion_1 = require("./getVersion");
const send = (params) => (Object.assign({ ins: 16 }, params));
function* getExtendedPublicKeys(version, paths) {
    getVersion_1.ensureLedgerAppVersionCompatible(version);
    const result = [];
    for (let i = 0; i < paths.length; i++) {
        const pathData = Buffer.concat([
            serialize_1.path_to_buf(paths[i]),
        ]);
        let response;
        if (i === 0) {
            const remainingKeysData = paths.length > 1
                ? serialize_1.uint32_to_buf(paths.length - 1)
                : Buffer.from([]);
            response = yield send({
                p1: 0,
                p2: 0,
                data: Buffer.concat([pathData, remainingKeysData]),
                expectedResponseLength: internal_1.EXTENDED_PUBLIC_KEY_LENGTH,
            });
        }
        else {
            response = yield send({
                p1: 1,
                p2: 0,
                data: pathData,
                expectedResponseLength: internal_1.EXTENDED_PUBLIC_KEY_LENGTH,
            });
        }
        const VKEY_LENGTH = 32;
        const CHAINCODE_LENGTH = 32;
        const [publicKey, chainCode, rest] = ioHelpers_1.chunkBy(response, [VKEY_LENGTH, CHAINCODE_LENGTH]);
        assert_1.assert(rest.length === 0, "invalid response length");
        result.push({
            publicKeyHex: publicKey.toString("hex"),
            chainCodeHex: chainCode.toString("hex"),
        });
    }
    return result;
}
exports.getExtendedPublicKeys = getExtendedPublicKeys;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0RXh0ZW5kZWRQdWJsaWNLZXlzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ludGVyYWN0aW9ucy9nZXRFeHRlbmRlZFB1YmxpY0tleXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EsZ0RBQThEO0FBRTlELDRDQUF3QztBQUN4QyxrREFBNEM7QUFDNUMsa0RBQStEO0FBRy9ELDZDQUErRDtBQUcvRCxNQUFNLElBQUksR0FBRyxDQUFDLE1BS2IsRUFBYyxFQUFFLENBQUMsaUJBQUcsR0FBRyxRQUE2QixNQUFNLEVBQUcsQ0FBQTtBQUc5RCxRQUFlLENBQUMsQ0FBQyxxQkFBcUIsQ0FDbEMsT0FBZ0IsRUFDaEIsS0FBNEI7SUFFNUIsNkNBQWdDLENBQUMsT0FBTyxDQUFDLENBQUE7SUFTM0MsTUFBTSxNQUFNLEdBQUcsRUFBRSxDQUFBO0lBRWpCLEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxLQUFLLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFO1FBQ25DLE1BQU0sUUFBUSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUM7WUFDM0IsdUJBQVcsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUM7U0FDeEIsQ0FBQyxDQUFBO1FBRUYsSUFBSSxRQUFnQixDQUFBO1FBQ3BCLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRTtZQUtULE1BQU0saUJBQWlCLEdBQ3pCLEtBQUssQ0FBQyxNQUFNLEdBQUcsQ0FBQztnQkFDWixDQUFDLENBQUMseUJBQWEsQ0FBQyxLQUFLLENBQUMsTUFBTSxHQUFHLENBQWEsQ0FBQztnQkFDN0MsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUE7WUFFbkIsUUFBUSxHQUFHLE1BQU0sSUFBSSxDQUFDO2dCQUNsQixFQUFFLEdBQVM7Z0JBQ1gsRUFBRSxHQUFXO2dCQUNiLElBQUksRUFBRSxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUMsUUFBUSxFQUFFLGlCQUFpQixDQUFDLENBQUM7Z0JBQ2xELHNCQUFzQixFQUFFLHFDQUEwQjthQUNyRCxDQUFDLENBQUE7U0FDTDthQUFNO1lBRUgsUUFBUSxHQUFHLE1BQU0sSUFBSSxDQUFDO2dCQUNsQixFQUFFLEdBQWE7Z0JBQ2YsRUFBRSxHQUFXO2dCQUNiLElBQUksRUFBRSxRQUFRO2dCQUNkLHNCQUFzQixFQUFFLHFDQUEwQjthQUNyRCxDQUFDLENBQUE7U0FDTDtRQUVELE1BQU0sV0FBVyxHQUFHLEVBQUUsQ0FBQTtRQUN0QixNQUFNLGdCQUFnQixHQUFHLEVBQUUsQ0FBQTtRQUMzQixNQUFNLENBQUMsU0FBUyxFQUFFLFNBQVMsRUFBRSxJQUFJLENBQUMsR0FBRyxtQkFBTyxDQUFDLFFBQVEsRUFBRSxDQUFDLFdBQVcsRUFBRSxnQkFBZ0IsQ0FBQyxDQUFDLENBQUE7UUFDdkYsZUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLEtBQUssQ0FBQyxFQUFFLHlCQUF5QixDQUFDLENBQUE7UUFFcEQsTUFBTSxDQUFDLElBQUksQ0FBQztZQUNSLFlBQVksRUFBRSxTQUFTLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQztZQUN2QyxZQUFZLEVBQUUsU0FBUyxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUM7U0FDMUMsQ0FBQyxDQUFBO0tBQ0w7SUFFRCxPQUFPLE1BQU0sQ0FBQTtBQUNmLENBQUM7QUEzREQsc0RBMkRDIn0=